<template>
  <div class="import-statistics">
    <div class="container">
      <div class="import-statistics__title">
        {{ $t('import_statistics.title') }}
      </div>
      <div class="import-statistics__form">
        <div class="import-statistics__field">
          <div class="import-statistics__label">{{ $t('import_statistics.file_label') }}</div>
          <input
            ref="fileInput"
            class="import-statistics__input"
            type="file"
            accept=".xls,.xlsx"
            @change="onFileChange"
          />
          <div v-if="fileError" class="import-statistics__error">{{ fileError }}</div>
        </div>
        <ButtonElement
          :text="$t('import_statistics.import_button')"
          :disabled="isLoading || !selectedFile"
          @click-button="importFile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';

export default {
  name: 'ImportStatistics',
  components: {
    ButtonElement,
  },
  data() {
    return {
      selectedFile: null,
      fileError: '',
      isLoading: false,
    };
  },
  methods: {
    onFileChange(e) {
      const [file] = e.target.files || [];
      this.selectedFile = file || null;
      this.fileError = '';
    },
    getBackendFileError(error) {
      const data = error?.response?.data;
      const errors = data?.errors;
      if (!errors) return this.$t('import_statistics.error_default');
      if (typeof errors === 'string') return errors;
      if (Array.isArray(errors?.file) && errors.file.length) return errors.file[0];
      if (typeof errors?.file === 'string') return errors.file;
      if (typeof errors?.general === 'string') return errors.general;
      return data?.message || this.$t('import_statistics.error_default');
    },
    async importFile() {
      this.fileError = '';
      this.isLoading = true;
      try {
        const token = localStorage.getItem('token');
        await this.$store.dispatch('Reports/importStatisticsFile', {
          token,
          file: this.selectedFile,
        });

        this.$notify({
          type: 'success',
          message: this.$t('import_statistics.success'),
        });
        this.selectedFile = null;
        if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      } catch (error) {
        this.fileError = this.getBackendFileError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/mixin';
@import '@/assets/styles/helpers/variables';

.import-statistics {
  padding: 5rem 0;

  &__title {
    font-weight: 700;
    font-size: 3rem;
    line-height: 3.6rem;
    margin-bottom: 3rem;

    @include below($lg) {
      font-size: 24px;
      line-height: 1.4;
      margin-bottom: 24px;
    }

    @include below($sm) {
      font-size: 20px;
      margin-bottom: 16px;
    }
  }

  &__form {
    max-width: 520px;
  }

  &__label {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &__input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    margin-bottom: 8px;
  }

  &__error {
    color: #f56c6c;
    font-size: 1.2rem;
    margin-bottom: 12px;
  }
}
</style>
